import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        dialog: {
            textAlign: 'left',
            direction: 'ltr',
            padding: theme.spacing(2),
            lineHeight: 2,
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
        cancelButton: {
            marginLeft: '5px',
        },
        addButton: {
            [theme.breakpoints.up('md')]: {
                transform: 'translate(5px, 31px)',
            },
        },
        isLoading: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '16px 0',
        },
        isError: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            margin: '16px 0',
        },
        titleCategory: {
            fontWeight: 'bold',
            fontSize: '13px',
        },
        subItem: {
            fontSize: '12px',
            display: 'flex',
            //alignItems: 'center',
        },
        iconStyle: {
            //opacity: '0.4',
            width: '0.8em',
            height: '0.8em',
            border: '1px solid #ccc',
            backgroundColor: '#e5e5e5',
            borderRadius: '50%',
        },
        iconTop: {
            color: 'white',
            backgroundColor: '#2B3990'
        },
        fonticon8: {
            width: '0.7em',
            height: '0.7em',
            color: '#43a047',
            margin: '0 4px',
            marginTop: '4px'
        },
        headItem: {
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            backgroundColor: '#f4f4f4',
            padding: '10px',
            borderRadius: '4px',
            fontSize: '12px',
        },
        label: {
            fontSize: '13px',
            color: '#455a64',
            marginBottom: 6,
            '&.MuiInputLabel': {
                '&-shrink': {
                    transform: 'translate(0, -2px) scale(1)',
                },
            },
        },
        collpaseContent: {
            //border:'1px solid #f4f4f4',
            borderTop: 'none',
            //borderRadius: '4px',
            //boxShadow:'3px 7px 12px -4px #f4f4f4',
            //boxShadow: '-2px 3px 10px 0px #f2ebeb',
            margin: '0 2px',
            minHeight: '180px',
        },
        mr8: {
            marginRight: '8px'
        },
        mr4: {
            marginRight: '4px',
            padding: '8px',
            marginTop: '12px',
            minHeight: '100px',

        },
        pd16: {
            padding: '16px !important'
        },

        colllapseTop: {
            margin: '8px 0',
            borderRadius: '4px',
            border: '1px solid #eeeeee'

        },

        btnSabt: {
            width: '97%',
            [theme.breakpoints.down('lg')]: {
                width: '97%',
            },
            [theme.breakpoints.down('sm')]: {
                width: '93%',
            },
        },

        customClassDate: {
            position: 'absolute',
            fontSize: '20px',
           // left: '84px',
            bottom: '6px'
        },
        customClassUploadTooltip: {
            position: 'absolute',
            fontSize: '20px',
            bottom: '2px'
            //left: '84px',
        },
        chip: {
            marginBottom: 8,
            marginInlineEnd: 5,
            backgroundColor: theme.palette.primary.lighter,
            '&:focus': {
              backgroundColor: theme.palette.primary.light,
            },
            '&:hover': {
              backgroundColor: theme.palette.primary.light,
            },
          },
    };
})